// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e383ead0","239":"68a3061a","453":"877aa53f","667":"012fe754"}[chunkId] + ".chunk.js";
};